export default __webpack_public_path__ + "static/spdash-1197d4e63e8fef7d92ff12bf4d6194b7.png";